const translations = {
  en: {
    depositUsing: 'Deposit using',
    amount: 'Amount',
    depositMinimum: 'Deposit Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    accountPlaceholder: 'Account',
    transactionIDPlaceholder: 'TransactionID',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    city: 'City',
    zipCode: 'Zip Code',
    address: 'Address',
    address2: 'Address 2',
    notes: 'Notes',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    amountNotPermitted: 'amount not permitted',
    depositStatus: 'Deposit Status',
    yourTransactionInitiated: 'Your transaction has been initiated.',
    pleaseSendTo: 'Please send your payment to:',
    wallet: 'Wallet',
    andIncludeMemo: 'and include in the memo:',
    tnxId: 'Tnx ID',
    copy: 'Copy',
    copied: 'Copied',
    transactionIdLabel: 'Transaction ID:',
    errorGettingCustomerInfo: 'Error getting customer info: ',
    copyLabel: 'Copy',
    // Alert style for the copy block (kept in English so it can be reused across locales)
  },
  es: {
    depositUsing: 'Depósito usando',
    amount: 'Monto',
    depositMinimum: 'Depósito mínimo',
    maximum: 'máximo',
    noLimit: 'Sin límite',
    accountPlaceholder: 'Cuenta',
    transactionIDPlaceholder: 'ID de Transacción',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    city: 'Ciudad',
    zipCode: 'Código Postal',
    address: 'Dirección',
    address2: 'Dirección 2',
    notes: 'Notas',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    amountNotPermitted: 'Monto no permitido',
    depositStatus: 'Estado del depósito',
    yourTransactionInitiated: 'Su transacción ha sido iniciada correctamente.',
    pleaseSendTo: 'Por favor, envíe su pago a:',
    wallet: 'Wallet',
    andIncludeMemo: 'e incluya en el memo:',
    tnxId: 'ID Trx',
    copy: 'Copiar',
    copied: 'Copiado',
    transactionIdLabel: 'ID de la transacción:',
    errorGettingCustomerInfo: 'Error al obtener la información del cliente: ',
    copyLabel: 'Copiar',
  },
  pt: {
    depositUsing: 'Depósito usando',
    amount: 'Valor',
    depositMinimum: 'Depósito mínimo',
    maximum: 'máximo',
    noLimit: 'Sem limite',
    accountPlaceholder: 'Conta',
    transactionIDPlaceholder: 'ID da Transação',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    phone: 'Telefone',
    email: 'E-mail',
    city: 'Cidade',
    zipCode: 'CEP',
    address: 'Endereço',
    address2: 'Endereço 2',
    notes: 'Notas',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    amountNotPermitted: 'Valor não permitido',
    depositStatus: 'Status do Depósito',
    yourTransactionInitiated: 'Sua transação foi iniciada com sucesso.',
    pleaseSendTo: 'Por favor, envie seu pagamento para:',
    wallet: 'Wallet',
    andIncludeMemo: 'e inclua no memo:',
    tnxId: 'ID Trx',
    copy: 'Copiar',
    copied: 'Copiado',
    transactionIdLabel: 'ID da transação:',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
    copyLabel: 'Copiar',
  },
}

export default translations
